import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  lastNotification: {}
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
